import type { ParsedCreativeHashData } from "./parse-creative-hash-data";

export interface DrawerNarrativeContent {
  topics: string;
  presenterAge: string;
  targetAudience: string;
  angle: string;
  painPoint: string;
  motivation: string;
  persona: string;
  concepts: string[];
  sequence: ParsedCreativeHashData["sequence"];
  verbalHooks: string;
  textOverlay: string;
}

function joinOrEmpty(values: string[], emptyValue: string): string {
  return values.length > 0 ? values.join(", ") : emptyValue;
}

export function mapDrawerNarrativeContent(
  parsed: ParsedCreativeHashData | null,
  emptyValue: string,
): DrawerNarrativeContent {
  if (!parsed) {
    return {
      topics: emptyValue,
      presenterAge: emptyValue,
      targetAudience: emptyValue,
      angle: emptyValue,
      painPoint: emptyValue,
      motivation: emptyValue,
      persona: emptyValue,
      concepts: [],
      sequence: [],
      verbalHooks: emptyValue,
      textOverlay: emptyValue,
    };
  }

  return {
    topics: joinOrEmpty(parsed.topics, emptyValue),
    presenterAge: joinOrEmpty(parsed.Age, emptyValue),
    targetAudience: joinOrEmpty(parsed.target_audience, emptyValue),
    angle: joinOrEmpty(parsed.angle, emptyValue),
    painPoint: joinOrEmpty(parsed.painPoint, emptyValue),
    motivation: joinOrEmpty(parsed.motivation, emptyValue),
    persona: joinOrEmpty(parsed.personalities, emptyValue),
    concepts: parsed.concepts,
    sequence: parsed.sequence,
    verbalHooks: parsed.verbalHooks ?? emptyValue,
    textOverlay: parsed.textOverlay ?? emptyValue,
  };
}
